module["exports"] = [
  "ukr.net",
  "ex.ua",
  "e-mail.ua",
  "i.ua",
  "meta.ua",
  "yandex.ua",
  "gmail.com"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/internet/free_email.js
// module id = 1785
// module chunks = 0